import { FC, PropsWithChildren, useState } from 'react'

import { NotificationPaginationContext } from './useNotificationPaginationContext'

export const NotificationPaginationContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [page, setPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(50)

  return (
    <NotificationPaginationContext.Provider
      value={{
        page,
        pageSize,
        setPage,
        setPageSize,
      }}
    >
      {children}
    </NotificationPaginationContext.Provider>
  )
}
